module.exports = __webpack_public_path__ + "static/img/ios_tr.0cea38d0.png";